document.addEventListener("DOMContentLoaded", () => {
  const floatingCart = document.getElementById("bw-floating-cart");
  const button = floatingCart?.querySelector(".bw-floating-cart__button");
  const count = document.getElementById("bw-cart-count");
  const total = document.getElementById("bw-cart-total");
  const cartDrawer = document.querySelector("cart-drawer");

  if (!floatingCart || !button) return;

  const moneyFormat = floatingCart.dataset.moneyFormat;

  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function hideFloatingCart() {
    floatingCart.classList.add("is-hidden");
  }

  function showFloatingCart() {
    floatingCart.classList.remove("is-hidden");
  }

  async function refreshCart() {
    try {
      const response = await fetch("/cart.js", {
        cache: "no-store",
      });

      const cart = await response.json();

      if (cart.item_count === 0) {
        floatingCart.style.display = "none";
        return;
      }

      floatingCart.style.display = "block";

      count.textContent =
        `${cart.item_count} ${cart.item_count === 1 ? "Item" : "Items"}`;

      total.textContent = formatMoney(cart.total_price);
    } catch (error) {
      console.error("Floating Cart:", error);
    }
  }

  // Initial load
  refreshCart();

  // Open Shopify cart drawer
  button.addEventListener("click", () => {
    if (cartDrawer?.open) {
      hideFloatingCart();
      cartDrawer.open(button);
    } else {
      window.location.href = "/cart";
    }
  });

  // Hide / Show widget when drawer opens or closes
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      if (cartDrawer.classList.contains("active")) {
        hideFloatingCart();
      } else {
        showFloatingCart();
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // Refresh after ANY Shopify cart request
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const url = String(args[0]);

    if (
      url.includes("/cart/add") ||
      url.includes("/cart/change") ||
      url.includes("/cart/update") ||
      url.includes("/cart/clear")
    ) {
      // Wait for Shopify to finish updating the cart
      setTimeout(refreshCart, 300);
    }

    return response;
  };
});